export default class VoucherDetailsResponse {
    constructor(supportedLocales) {
        this.translations = [];
        this.id = null;
        this.dateFrom = undefined;
        this.dateTo = undefined;
        this.cost = undefined;
        this.title = undefined;
        this.amount = undefined;
        this.qrCodes = [];
        this.maxPerUser = undefined;
        this.image = undefined;
        this.category = undefined;
        this.partner = undefined;
        this.amountAllAlreadyBoughtVouchers = undefined;
        this.status = undefined;
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                description: null,
            };
        });
        this.supportedLocales = supportedLocales;
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;
            to.dateFrom = new Date(from.dateFrom);
            to.dateTo = new Date(from.dateTo);
            to.cost = from.cost;
            to.amount = from.amount;
            to.title = from.title;
            to.maxPerUser = from.maxPerUser;
            to.image = from.image;
            to.qrCodes = from.qrCodes;
            to.category = from.category;
            to.partner = from.partner;
            to.amountAllAlreadyBoughtVouchers = from.amountAllAlreadyBoughtVouchers;
            to.status = from.status;
            to.supportedLocales.forEach((element) => {
                to.translations[element] = {
                    title: from.translations[element]?.title,
                    description: from.translations[element]?.description,
                };
            });
            to.unlimitedVouchers = from.unlimited;
            to.visibleToAll = from.visibleToAll;
        } else {
            to = new VoucherDetailsResponse();
        }
    }

    static copy(to, from) {
        VoucherDetailsResponse.assign(from, to);
        return to;
    }
}
